import { Link } from "react-router-dom";
import { HiOutlinePencilAlt } from "react-icons/hi";

/**
 * Returns the User Table Row data component.
 *
 * @returns The User Table Row data component.
 */
const UserRow = ({ user, setShow, ...props }) => {
    const userApprovalHandler = () => {
        props.selectedUserHandler(user);
    };

    return (
        <>
            <tr className="py-12">
                <td className="w-full max-w-0 py-4 pl-6 pr-3 text-sm sm:text-base font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                    {`${user.fname} ${user.lname}`}

                    <dl className="font-normal lg:hidden">
                        <dt className="sr-only sm:hidden">Email</dt>
                        <dd className="mt-1 truncate text-gray-500 sm:hidden">{user.userEmail}</dd>
                    </dl>
                </td>

                <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">{user.userEmail}</td>
                <td className="px-3 py-4 text-sm sm:text-base text-gray-500">{user.role}</td>

                <td className="py-4 pl-3 pr-6 space-y-3 text-right text-sm sm:text-base font-medium sm:space-y-0 sm:space-x-3 sm:pr-6">
                    <Link
                        to={{
                            state: {
                                userId: user.id,
                                username: user.username,
                                contributorAccess: user.contributorAccess || user.role === 'Contributors'
                            },
                            pathname: `/admin/user-management/edit-user/${user.id}`,
                        }}
                        data-cy={"edit-" + user.email}
                        className="inline-flex items-center text-sm p-1 sm:text-base border border-transparent leading-4 font-medium rounded-full text-white bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <HiOutlinePencilAlt className="w-6 h-6 text-gray-400" />
                        <span className="sr-only">, {`${user.fname} ${user.lname}`}</span>
                    </Link>
                </td>
            </tr>
        </>
    );
}

export default UserRow;